import { render, staticRenderFns } from "./AddDataRefCat.vue?vue&type=template&id=59d92dd0&"
import script from "./AddDataRefCat.vue?vue&type=script&lang=ts&"
export * from "./AddDataRefCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports